
<div class="header-toolbar">
  <h1>Registres</h1>
</div>

<div class="settings">
  <a class="item" routerLink="/documents-ledger/companies">
    <t-icon name="folder_seal_check"></t-icon>
    <div class="text">Sociétés</div>
  </a>

  <a class="item" routerLink="/documents-ledger/root-certificates">
    <t-icon name="file_seal_check"></t-icon>
    <div class="text">Certificats racine</div>
  </a>

  <a class="item" routerLink="/documents-ledger/settings">
    <t-icon name="settings"></t-icon>
    <div class="text">Paramètres</div>
  </a>
</div>